import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import './ArticleContainer.scss';
import MainTitle from '../MainTitle';
import Details from '../Details';
import ImgArt from '../ImgArt';
import SocialAction from '../SocialAction';
import Tag from '../Tag';
import { updateSelectedArticle } from '../../../../../store/actions/ArticlesActions';
import { getLaywerUserById } from '../../../../../configs/environments/firebase/firebaseApp';

function ArticleContainer(props) {
  const {
    article,
    isFeatured,
    userId,
    updateSelectedArticle,
    //getSuggestedArticles,
  } = props;
  const styleSocial = {
    marginBottom: 48,
    socialActionContainerButtonShare: {
      display: 'none',
    },
  };

  const date = moment
    .unix(article && article.createdAt && article.createdAt._seconds)
    .utc()
    .format('D MMMM YYYY');
    

  const handleLike = async () => {
    await updateSelectedArticle(article, userId, 'like');
    /* const params = {
      page: 1,
      limit: 4,
      category: article.categories[0],
    };
    await getSuggestedArticles(params, article.id); */
  };

  const [author, setAuthor] = useState('')
  
  useEffect(() => {
    if(article && article.createdBy && article.createdBy.typeUser === 'lawyer') {
      setAuthor(article.lawyerUser); 
    }else {
      setAuthor('Contacta Abogado®');
    }
    // article && article.createdBy && 
    // getLaywerUserById(article.createdBy)
    // .then((user => {
    //   if(user && user.role === 'lawFirm'){
    //     setAuthor(user.officeName)
    //   }else {
    //     setAuthor(`${user.name} ${user.firstLastName} ${user.secondLastName}`)
    //   }
    // }))
    // .catch(err =>{
    //   setAuthor('Contacta Abogado®')
    // })
  }, [article])


  return (
    <div className="article-container">
      {isFeatured && (
        <div className="marker">
          <img
            src="/img/marker/icon.svg"
            alt="marcador de artículo destacado"
          />
        </div>
      )}
      <div>
        <MainTitle text={article && article.title}></MainTitle>
        <Details
          margin="featured"
          author={author}
          date={date}
          time={article && article.readingTime}
        />
        <ImgArt image={article && article.mainImage} styleImg="featured" />
        <div className="article-container-subheader"></div>
        <div className="article-container-lead-paragraph">
          <p>{article && article.articleSummary}</p>
        </div>
        <div className="article-container-text">
          <div dangerouslySetInnerHTML={{ __html: article && article.descriptions }} />
          <SocialAction
            likes={article && article.numberLike}
            likeUsers={article && article.like}
            style={styleSocial}
            handleLike= {handleLike}
          />
          <div className="article-container-tags">
            {article && article.categories &&
              article && article.categories.map((tag, index) => (
                <Tag tagName={tag} key={index} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateSelectedArticle: (article, userId) =>
    dispatch(updateSelectedArticle(article, userId)),
  //getSuggestedArticles: (params, id) => dispatch(getSuggestedArticles(params, id)),
});

const mapStateToProps = (state) => ({
  userId: state.authClient.uid,
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticleContainer);
